<script setup lang="ts">
type QaEquipmentIotInformationSectionProps = {
  entityId: string;
};
type QaEquipmentIotInformationEmits = {
  openDialog: [];
};

defineProps<QaEquipmentIotInformationSectionProps>();
defineEmits<QaEquipmentIotInformationEmits>();
</script>

<template>
  <p class="text-body-2 font-weight-medium mb-2 text-primary">
    {{ $t('YourEquipmentIsOfflineMsg') }}
    <a href="#" @click.prevent="$emit('openDialog')">
      {{ $t('MoreInformation') }}
    </a>
  </p>
  <VDivider class="mt-5" />
</template>
